<template>
    <v-app-bar absolute color="white" elevate-on-scroll class="pa-0" elevation="0" rounded="0">
        <v-row no-gutters class="fill-height">
            <v-col cols="2" class="d-flex align-center">
                <v-btn-icon
                    style="pointer-events: auto"
                    v-if="backBtnList[$router.currentRoute.value.name]"
                    color="secondary"
                    @click.stop="onBack"
                    icon="$oss-chevron-left"
                >
                </v-btn-icon>
            </v-col>
            <v-col cols="8" class="d-flex align-center pl-2">
                <v-text-field
                    placeholder="Entreprise sélectionnée"
                    v-model="selectedCompanyName"
                    readonly
                    hide-details
                    class="oss-bordered bordered-large"
                    data-cy="index-selectCompany"
                    :style="topButtonStyle"
                    @click="onCompanySelectClick"
                ></v-text-field>
            </v-col>
            <v-col cols="2" class="rounded-bl-lg d-flex align-center justify-end pl-2">
                <v-btn-icon
                    icon="$oss-outlined-user"
                    :style="topButtonStyle"
                    @click="onUserBtnClick"
                    data-cy="index-showUserProfile"
                >
                </v-btn-icon>
            </v-col>
        </v-row>
    </v-app-bar>
</template>
<script lang="ts">
import { Component, Vue, toNative, Watch, Prop, Model } from "vue-facing-decorator";

@Component({
    emits: ["back", "companySelectClick", "userBtnClick"],
})
class MobileAppBar extends Vue {
    @Model({ name: "selectedCompany", type: String }) selectedCompanyName: string;
    @Prop({ default: "", type: String }) topButtonStyle: string;

    backBtnList = {
        "reconciliation/bankTransaction": 1,
        "reconciliation/document": 1,
        toBeDone: 1,
        document: 1,
        expenseReportNew: 1,
        expenseReport: 1,
        zTillReceipt: 1,
    };

    onCompanySelectClick() {
        this.$emit("companySelectClick");
    }

    onBack() {
        this.$emit("back");
    }

    onUserBtnClick() {
        this.$emit("userBtnClick");
    }

    get companyName() {
        return this.selectedCompanyName;
    }

    set companyName(value: string) {
        this.$emit("update:selectedCompanyName", value);
        this.selectedCompanyName = value;
    }
}

export default toNative(MobileAppBar);
</script>
